import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=36a5b4e5&scoped=true&"
import script from "./TreeItem.vue?vue&type=script&lang=ts&"
export * from "./TreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=36a5b4e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5b4e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
